import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import AuthRoute from './AuthRoute';
import Overview from 'pages/logistics/overview';
import Partners from 'pages/logistics/partners';
import LiveTrips from 'pages/live-trips';
import SearchResult from 'pages/search/search-results';
import Search from 'pages/search';
import Settings from 'pages/logistics/settings';
import PaymentHistory from 'pages/logistics/payment-history';
import LocationSettings from 'pages/logistics/location-settings';
import Security from 'pages/logistics/security';
import OrderHistory from 'pages/logistics/order-history';
import RecentlyDeleted from 'pages/logistics/bin';
import { LOGISTICS_ROUTE_KEYS, SECURITY_ROUTE_KEYS } from 'utils/constants';
import LogisticsTeamStats from 'pages/logistics/logistics-team-stats';
import ScheduledOrders from 'pages/logistics/scheduled-orders';
import PolygonRiders from 'pages/logistics/overview/polygon-riders';
import DashboardLayout from 'layouts/dashboard.layout';
import { getInitialRoute } from 'utils/role-config';
import UserProfile from 'pages/user';
import FcbDeliveries from 'pages/logistics/fcbDeliveries';
import RecalledOrders from 'pages/recalled-orders';

import ClearLocalStorage from 'pages/clear-local-storage';

import ExternalRiderHOCPage from 'pages/external-rider/external-rider-hoc';
import DeliveryManagment from 'pages/logistics/delivery-managment';

const LOGISTICS_CHILD_ROUTES: RouteObject[] = [
  {
    path: LOGISTICS_ROUTE_KEYS.DASHBOARD,
    element: <Navigate to={getInitialRoute()} />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.OVERVIEW,
    element: <Overview />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.LIVE_TRIPS,
    element: <LiveTrips />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.RECALLED_ORDERS,
    element: <RecalledOrders />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.PARTNERS,
    element: <Partners />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.SCHEDULED,
    element: <ScheduledOrders />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.SEARCH,
    element: <Search />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.SEARCH_RESULT,
    element: <SearchResult />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.SETTINGS,
    element: <Settings />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.PAYMENT_HISTORY,
    element: <PaymentHistory />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.BIN,
    element: <RecentlyDeleted />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.ORDER_HISTORY,
    element: <OrderHistory />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.FCB_DELIVERIES,
    element: <FcbDeliveries />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.CLEAR_STORAGE,
    element: <ClearLocalStorage />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.LOCATION,
    element: <LocationSettings />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.TEAM_STATS,
    element: <LogisticsTeamStats />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.POLYGON_RIDERS,
    element: <PolygonRiders />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.USER_PROFILE,
    element: <UserProfile />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.EXTERNAL_RIDERS,
    element: <ExternalRiderHOCPage />
  },
  {
    path: LOGISTICS_ROUTE_KEYS.DELIVERY_MANAGMENT,
    element: <DeliveryManagment />
  }
];

export const LOGISTICS_ROUTES: RouteObject[] = [
  {
    path: LOGISTICS_ROUTE_KEYS.DASHBOARD,
    element: (
      <AuthRoute>
        <DashboardLayout />
      </AuthRoute>
    ),
    children: LOGISTICS_CHILD_ROUTES
  }
];

const SECURITY_CHILD_ROUTES: RouteObject[] = [
  {
    path: SECURITY_ROUTE_KEYS.SECURITY,
    element: <Security />
  }
];
export const SECURITY_ROUTES: RouteObject[] = [
  {
    path: SECURITY_ROUTE_KEYS.DASHBOARD,
    element: (
      <AuthRoute>
        <DashboardLayout />
      </AuthRoute>
    ),
    children: SECURITY_CHILD_ROUTES
  }
];
